import { useEffect, useRef } from "react";

export default function ValutaServizioIframe({ iframeOrigin, src }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;

    const handleLoad = () => {
      if (!iframe?.contentWindow) return;
      iframe.contentWindow.postMessage(
        { parentUrl: window.location.href, title: document.title },
        iframeOrigin
      );
    };

    const handleMessage = (event) => {
      if (event.origin !== iframeOrigin) return;
      if (!event.data || typeof event.data.height !== "number") return;
      iframe.style.height = `${event.data.height}px`;
    };

    iframe?.addEventListener("load", handleLoad);
    window.addEventListener("message", handleMessage);

    return () => {
      iframe?.removeEventListener("load", handleLoad);
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeOrigin]);

  return (
    <iframe
      ref={iframeRef}
      id="valuta-servizio"
      src={src}
      width="100%"
      style={{ 
        border: '0',
        transition: 'height 0.3s ease',
        overflowY: 'hidden',
        backgroundColor: 'rgb(102, 2, 0)'
      }}
      title="Valuta Servizio"
      loading="lazy"
      scrolling="no"
      {...{ allowTransparency: "true" }}
    />
  );
}
